const getSlideWidth = ({ isMobile, isMobileOrTablet, windowWidth }) => {
  if (!windowWidth) {
    if (isMobile) return 420;
    if (isMobileOrTablet) return 800;
    return 1024;
  }

  return windowWidth;
};

export default getSlideWidth;
